import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Error = ({ error }) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState("")

  useEffect(() => {
    if(error) {
      let errorMessage = error?.data?.error ?? t("error.serverNotResponding");
    errorMessage = error?.error?.data?.message ?? errorMessage;
    errorMessage = error?.error?.data?.error ?? errorMessage;
    errorMessage = error?.data?.message ?? errorMessage;
    errorMessage = error?.data?.err ?? errorMessage;
    errorMessage = error?.data?.msg ?? errorMessage;
    setErrorMessage(errorMessage)
    } else {
      setErrorMessage(t("error.serverNotResponding"))
    }
  }, [error, t])
  return (
    <>
      <Alert variant="danger">
        <Alert.Heading>{t("error.errorAlertHeading")}</Alert.Heading>
        <p className="mb-0">
          {errorMessage}
        </p>
      </Alert>
    </>
  );
};

export default Error;
